import { useAuthentication } from '@src/authentication/useAuthentication';
import { isClientUser } from '@src/clientUser/useClientUser';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { OrderSummary } from '@src/orders/components/OrderSummary';
import { PermitSummaries } from '@src/orders/components/PermitSummaries';
import { OrderCompletedByClientBanner } from '@src/orders/components/preauthorization/OrderCompletedByClientBanner';
import { PreauthorizationBanner } from '@src/orders/components/preauthorization/PreauthorizationBanner';
import type { OrderListing } from '@src/orders/domain/OrderList';

type Props = {
  order: OrderListing;
  onDeleteSuccess: () => void;
  onOrderChange: () => void;
  onPermitChange: (order: OrderListing) => void;
  highlightedPermit?: string;
};

export const OrderDetails = ({
  order,
  onOrderChange,
  onPermitChange,
  onDeleteSuccess,
  highlightedPermit,
}: Props) => {
  const { user } = useAuthentication();
  const showCompletedByClientBanner =
    !isClientUser(user) &&
    order.isInNewCategory() &&
    order.wasSubmittedByClient();

  return (
    <>
      <Stack gap={theme.spacing['4']}>
        {showCompletedByClientBanner && (
          <OrderCompletedByClientBanner
            submissionState={order.clientSubmissionState}
          />
        )}

        <PreauthorizationBanner order={order} />
      </Stack>

      <OrderSummary
        order={order}
        onAssign={onOrderChange}
        onDeleteSuccess={onDeleteSuccess}
        onStatusChange={onOrderChange}
      />

      <PermitSummaries
        order={order}
        onChange={onPermitChange}
        onAssign={onOrderChange}
        highlightedPermit={highlightedPermit}
      />
    </>
  );
};
